<template>
  <div>
    <o-section :overlay="true">
      <div class="u-center">
        <p>
          Je vind het nummer van je identiteitskaart terug op de voorzijde van
          je Belgische identiteitskaart.
        </p>
        <p>
          <img
            src="/images/id-info.svg"
            class="c-card-example"
            width="198"
            alt="ID card"
          />
        </p>
      </div>
    </o-section>
  </div>
</template>

<script>
export default {
  name: 'OIdInfo'
}
</script>
